<template>
  <Scenario route_type="drive"/>
</template>

<script>
import Scenario from "@/components/common/views/core/scenario.vue";
export default {
    components:{
        Scenario
    }
}
</script>